import React, { useMemo, useState } from "react";
import jsonExport from "jsonexport/dist";

import { MenuItem, TextField as SelectField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import {
  downloadCSV,
  useList,
  useListContext,
  Button,
  Datagrid,
  FilterButton,
  ListContextProvider,
  ListToolbar,
  NumberField,
  TextField,
  TopToolbar,
} from "react-admin";

import { ExportIcon } from "../../../components/common/iconography";
import { Pagination } from "../../../components/Pagination";

const _ = require("lodash");

const useStyles = makeStyles((theme) => ({
  selectField: {
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(1),
    minWidth: "12rem",
  },
}));

const exporter = (reportBy, inventories) => {
  debugger;
  let columns = [];
  let inventoriesForExport = [];

  if (reportBy === "productId") {
    columns = [
      "Customer",
      "Product Code",
      "Product",
      "Qty. On Hand",
      "Qty. Physical",
      "UOM",
    ];

    inventoriesForExport = inventories.map((inventory) => {
      const inventoryForExport = {
        accountName: inventory.accountName,
        productCode: inventory.productCode,
        productName: inventory.productName,
        quantityOnHand: inventory.quantityOnHand,
        quantityPhysical: inventory.quantityPhysical,
        inventoryUOM: inventory.inventoryUOM,
      };
      debugger;

      return inventoryForExport;
    });
  } else {
    columns = [
      "Customer",
      "Lot Number",
      "Product",
      "Qty. On Hand",
      "Qty. Physical",
      "UOM",
    ];

    inventoriesForExport = inventories.map((inventory) => {
      const inventoryForExport = {
        accountName: inventory.accountName,
        lotNumber: inventory.lotNumber,
        productName: inventory.productName,
        quantityOnHand: inventory.quantityOnHand,
        quantityPhysical: inventory.quantityPhysical,
        inventoryUOM: inventory.inventoryUOM,
      };

      return inventoryForExport;
    });
  }

  jsonExport(inventoriesForExport, { rename: columns }, (err, csv) => {
    downloadCSV(csv, `inventoryAudit_${new Date().toLocaleDateString()}`); // download as 'inventoryAudit__DATE.csv` file
  });
};

const ReportBySelect = ({
  label,
  variant,
  reportBy,
  setReportBy,
  ...props
}) => {
  const classes = useStyles();
  const choices = [
    { id: "lotNumber", name: "Lot Number" },
    { id: "productId", name: "Product Code" },
  ];

  return (
    <SelectField
      select
      label={label}
      size="small"
      margin="dense"
      variant={variant}
      className={classes.selectField}
      value={reportBy}
      onChange={(event) => setReportBy(event.target.value)}
      helperText={false}
    >
      {choices?.map((itm) => (
        <MenuItem key={itm.id} value={itm.id}>
          {itm.name}
        </MenuItem>
      ))}
    </SelectField>
  );
};

const getListFilters = (reportBy, setReportBy) => [
  <ReportBySelect
    label="Report By"
    variant="outlined"
    alwaysOn
    reportBy={reportBy}
    setReportBy={setReportBy}
  />,
];

const ListActions = ({ reportBy, ...props }) => {
  const { data } = useListContext();
  const inventories = Object.values(data);

  return (
    <TopToolbar>
      <FilterButton />
      <Button
        label="Export"
        disabled={inventories?.length === 0}
        onClick={() => exporter(reportBy, inventories)}
      >
        <ExportIcon />
      </Button>
    </TopToolbar>
  );
};

export const AuditReportTab = ({ record, ...props }) => {
  const [loaded, setLoaded] = useState(false);
  const [reportBy, setReportBy] = useState("lotNumber");
  const defaultSort = { field: "accountName", order: "ASC" };
  const defaultPerPage = 10;

  const finalData = useMemo(() => {
    debugger;
    if (
      Array.isArray(record.processedItems) &&
      record.processedItems?.length > 0
    ) {
      let reportData = [];

      if (reportBy === "productId") {
        reportData = _(record.processedItems)
          .groupBy("productId")
          .map((objs, key) => ({
            id: objs[0].id,
            accountName: objs[0].accountName,
            productId: key,
            productCode: objs[0].productCode,
            productName: objs[0].productName,
            quantityOnHand: objs.reduce(function (sum, record) {
              return record.reconciledQuantityOnHand
                ? sum + record.reconciledQuantityOnHand
                : sum + record.quantityOnHand;
            }, 0),
            quantityPhysical: objs.reduce(function (sum, record) {
              return record.reconciledQuantityPhysical
                ? sum + record.reconciledQuantityPhysical
                : sum + record.quantityPhysical;
            }, 0),
            inventoryUOM: objs[0].inventoryUOM,
          }))
          .value();
      } else {
        reportData = record.processedItems.map((item) => ({
          id: item.id,
          accountName: item.accountName,
          lotNumber: item.lotNumber,
          productName: item.productName,
          quantityOnHand: item.reconciledQuantityOnHand
            ? item.reconciledQuantityOnHand
            : item.quantityOnHand,
          quantityPhysical: item.reconciledQuantityPhysical
            ? item.reconciledQuantityPhysical
            : item.quantityPhysical,
          inventoryUOM: item.inventoryUOM,
        }));
      }

      setLoaded(true);
      return reportData;
    }
    return [];
  }, [record.processedItems, reportBy]);

  const listContext = useList({
    ...props,
    data: finalData,
    ids: finalData.map(({ id }) => id),
    loaded,
    sort: defaultSort,
    perPage: defaultPerPage,
    basePath: "/inventories",
    resource: "inventories",
  });

  return (
    <ListContextProvider value={listContext}>
      <ListToolbar
        {...props}
        filters={getListFilters(reportBy, setReportBy)}
        actions={<ListActions reportBy={reportBy} />}
      />
      <ReportGrid reportBy={reportBy} />
      <Pagination {...listContext} />
    </ListContextProvider>
  );
};

const ReportGrid = ({ reportBy, ...props }) => {
  return (
    <Datagrid rowClick={false} {...props}>
      <TextField source="accountName" label="Customer" />
      {reportBy === "productId" ? (
        <TextField source="productCode" label="Product Code" />
      ) : (
        <TextField source="lotNumber" label="Lot Number" />
      )}
      <TextField source="productName" label="Product Name" />
      <NumberField source="quantityOnHand" label="Qty. On Hand" />
      <NumberField source="quantityPhysical" label="Qty. Physical" />
      <TextField source="inventoryUOM" label="UOM" />
    </Datagrid>
  );
};
